import { render, staticRenderFns } from "./marble.vue?vue&type=template&id=ff342c92&"
import script from "./marble.vue?vue&type=script&lang=js&"
export * from "./marble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports